import { useEffect } from 'react';
import { apiService } from '../services/api';
import { useAuthStore } from '../store/authStore';

/**
 * Hook to preload common data that multiple pages use
 * This helps reduce perceived loading time when navigating
 */
export const usePreloadData = () => {
  const { user } = useAuthStore();

  useEffect(() => {
    if (!user) return;

    // Preload data in the background after a short delay
    const timer = setTimeout(() => {
      // These API calls will be cached by the cache service
      Promise.allSettled([
        apiService.getUsers({ limit: 100 }),
        apiService.getProjects(),
        apiService.getTasks({ limit: 200 }),
      ]).catch(() => {
        // Silently fail - this is just preloading
      });
    }, 2000); // Wait 2 seconds after page load

    return () => clearTimeout(timer);
  }, [user]);
};